<div class="container">

  <section class='header'>

    <app-header-dialog [iconName]="'person'">
      Atualização
    </app-header-dialog>

  </section>

  <form  name="entityForm" [formGroup]='entityForm' autocomplete="off">

    <div class='content'>

      <label style="margin-top: 20px;">
        <b>{{data.name}}</b>
      </label>

      <div style='margin: 20px auto 0 auto; width: 200px;'>
        <img style="width: 100%;" [src]="entityForm.controls.image.value" *ngIf="entityForm.controls.image.value">
      </div>

      <ckeditor [config]="{ 
        toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList' ] }"
        [formControl]="entityForm.controls.text" [editor]="Editor"></ckeditor>

      <div [innerHTML]="data.comments"
        style="width: 96%; height: 80px; overflow: auto; border: solid 1px silver; padding: 10px; margin: 10px 0 20px 0;">
      </div>

    </div>

  </form>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <div [ngClass]="{hidden: !spinner}">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
    <button *ngIf='!data.moved' type="submit" [disabled]="entityForm.invalid" mat-raised-button
      (click)="matDialogRef.close(['ok',entityForm])">
      <mat-icon>check_circle_outline</mat-icon>
    </button>
  </div>

</div>